import { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchTimeZones } from 'api/timezones';
import { DateTime } from 'luxon';
import { timezoneQueryKeys } from 'queries/timezone-query-keys';

interface Timezone {
    name: string;
    offset: string;
    offsetShort: string;
}

const useTimezones = (): Timezone[] => {
    const { data } = useSuspenseQuery({
        queryKey: [timezoneQueryKeys.all()],
        queryFn: () => fetchTimeZones(),
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: Infinity,
    });

    return useMemo(() => {
        return data?.map(name => {
            const dateTimeTz = DateTime.local({ zone: name });
            const offset = dateTimeTz.toFormat('ZZZZ');
            const offsetShort = dateTimeTz.toFormat('ZZ');
            return { name, offset, offsetShort };
        });
    }, [data]);
};

export { useTimezones };
export type { Timezone };
